export default __webpack_public_path__ + "static/media/telegram.58d33cb0.gif";